import { Activity } from "../../components/activity/types";
import { DateRange, HistoryQuery } from "../../types";
import Api from "../api";
import { parseApiData } from "../utils";

class ActivityApi extends Api {
  static getInRange(range: DateRange): Promise<Array<Activity>> {
    return this.getData(`/activity?from=${range.from}&to=${range.to}`);
  }

  static search(query: HistoryQuery): Promise<Array<Activity>> {
    return this.postData("/activity/search", parseApiData(query));
  }
}

export default ActivityApi;
